import { useMemo } from "react";

type ProjectAccessError = {
  response?: {
    status?: number;
    data?: {
      debugMessage?: string;
    };
  };
};

export const isProjectAccessError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") {
    return false;
  }

  const { response } = error as ProjectAccessError;
  const debugMessage = response?.data?.debugMessage;

  return response?.status === 418 && typeof debugMessage === "string" && debugMessage.includes("not have access to the project");
};

export const useProjectAccessError = (isError: boolean, error: unknown) => useMemo(() => isError && isProjectAccessError(error), [error, isError]);
